import PageLayout from "@/components/feature/PageLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HotSection from "@/pages/home/components/HotSection";
import NewSection from "@/pages/home/components/NewSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { mediaList } from "@/mocks/media";
import type { MediaItem } from "@/types/media";

const SLIDE_IDS = ["haohao-shiguang", "long-night-galaxy", "deep-sea-echo", "time-concert"];

export default function Home() {
  const all = mediaList as MediaItem[];
  const slides = SLIDE_IDS.map((id) => all.find((item) => item.id === id)).filter(
    (item): item is MediaItem => Boolean(item),
  );

  return (
    <PageLayout
      padded={false}
      title="桔子TV-好好的时光完整版免费在线观看平台"
      description="桔子TV为您提供电视剧《好好的时光》完整版免费播放，涵盖多种热门影视内容，方便用户在线观看和追剧体验。"
    >
      <HeroCarousel items={slides} />

      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="-mt-8 md:-mt-10 relative z-20">
          <CategoryEntries />
        </div>

        <div className="mt-12 md:mt-16">
          <HotSection items={all} />
        </div>

        <div className="mt-12 md:mt-16">
          <NewSection items={all} />
        </div>

        <div className="mt-12 md:mt-16">
          <SiteIntro />
        </div>
      </div>
    </PageLayout>
  );
}